import { FunctionComponent } from 'react'
import { ArrayLocationAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { Chip } from '@black-bear-energy/rucksack'

export const ArrayLocationChip: FunctionComponent<ArrayLocationChipProps> = ({
  arrayLocation,
}) => {
  const arrayLocationProperties: Record<
    ArrayLocationAPIResponse,
    {
      label: string
      color:
        | 'info'
        | 'secondary'
        | 'primary'
        | 'success'
        | 'warning'
        | 'default'
    }
  > = {
    rooftop: {
      label: 'Rooftop',
      color: 'info',
    },
    carport: {
      label: 'Carport',
      color: 'secondary',
    },
    parktop: {
      label: 'Parktop',
      color: 'primary',
    },
    ground: {
      label: 'Ground',
      color: 'success',
    },
    storage: {
      label: 'Storage',
      color: 'warning',
    },
    roofAndCarport: {
      label: 'Roof + Carport',
      color: 'default',
    },
    roofAndParktop: {
      label: 'Roof + Parktop',
      color: 'default',
    },
    carportAndParktop: {
      label: 'Carport + Parktop',
      color: 'default',
    },
    roofAndCarportAndParktop: {
      label: 'Roof + Carport + Parktop',
      color: 'default',
    },
  }

  return (
    <Chip
      label={arrayLocationProperties[arrayLocation].label}
      color={arrayLocationProperties[arrayLocation].color}
      variant="outlined"
      size="small"
      sx={{ backgroundColor: 'transparent' }}
    />
  )
}

interface ArrayLocationChipProps {
  arrayLocation: ArrayLocationAPIResponse
}
